/* eslint-disable @typescript-eslint/no-explicit-any */
import { useLocation, useNavigate } from "react-router";
import { AuthInfo } from "../data/types";
import { useApi } from "../data/api/useApi";
import { authManager } from "./authManager";
import { useClientPortalService } from "../data/services/useClientPortalService";
import { useUserAccountService } from "../data/services/useUserAccountService";

export const useLogin = () => {

    //Hooks
    const { clearAccount } = useUserAccountService();
    const portalService = useClientPortalService();
    const navTo = useNavigate();
    const location = useLocation();

    //Api
    const authApi = useApi<any>('api/Auth');

    //Logic
    const login = async (authInfo: AuthInfo) => {

        portalService.clearPortals();
        clearAccount();

        try{
            await authManager.authenticate(authInfo);
        } catch {
            portalService.clearPortals();
            throw new Error('Login Error');
        }
    }

    const logout = async () => {
        
        portalService.clearPortals();
        clearAccount();

        await authManager.logout();
        
        navTo(location.pathname, { replace: true });
    }

    const requestPWReset = async (username: string) => {
        await authApi.postAsync<any>({}, `requestPwChange/${username}`); 
    }

    const resetPW = async (resetPWForm: any) => {
        await authApi.postAsync<any>(resetPWForm, 'resetPW');
    }

    return {
        login,
        logout,
        requestPWReset,
        resetPW
    }
}